import { getApiClientErrorInfo } from '@nly/api-client'

const detailTranslations: Array<[RegExp, string]> = [
  [/metadata item with the same code already exists/i, '该编码的字典项已存在，请使用其他编码'],
  [/metadata type was not found/i, '业务字典类型尚未初始化或不存在'],
  [/metadata item was not found/i, '字典项不存在或已被删除'],
  [/metadata item name is required/i, '字典项名称不能为空且不能超过 100 个字符'],
  [/metadata item code is required/i, '字典项编码不能为空且不能超过 64 个字符'],
  [/metadata item sort order must be a non-negative integer/i, '排序必须为非负整数'],
  [/institution with this name already exists/i, '该医疗机构名称已存在，请选择已有机构'],
  [/overlapping weekly schedule/i, '该医生已有重叠的每周出诊安排'],
  [/in-progress doctor occurrence/i, '新时段与正在进行的历史出诊重叠'],
  [/no active version/i, '该安排没有可用的周期版本'],
  [/no longer active for this occurrence/i, '该出诊版本已失效，不能继续操作'],
  [/occurrence has started and is read-only/i, '该次出诊已经开始，只读且不能操作'],
  [/changed by another operator/i, '安排已被其他运营人员修改，请刷新后重试'],
  [/already disabled/i, '该安排已经停用'],
  [/database rejected this doctor schedule operation/i, '数据库拒绝了本次出诊安排操作，请稍后重试'],
  [/must use yyyy-mm-dd format/i, '日期必须使用 YYYY-MM-DD 格式'],
  [/date is invalid/i, '日期无效'],
  [/must use hh:mm format/i, '时间必须使用 HH:mm 格式'],
  [/start before it ends/i, '开始时间必须早于结束时间'],
  [/weekday must be between 1 and 7/i, '星期必须在周一至周日之间'],
  [/至少选择一个周期/, '至少选择一个周期'],
  [/周期不能重复选择同一天/, '不能重复选择同一天'],
  [/周期必须为 1 到 7/, '周期只能选择周一至周日'],
  [/occurrence date range cannot exceed/i, '查询日期范围不能超过 93 天'],
  [/page and page size are invalid/i, '分页参数无效'],
]

const codeMessages: Record<string, string> = {
  CONFLICT: '操作与当前数据状态冲突，请刷新后重试',
  DATABASE_UNAVAILABLE: '数据源暂时不可用，请稍后重试',
  NOT_FOUND: '请求的数据不存在，可能已被其他人员修改',
  VALIDATION_ERROR: '提交的数据无效，请检查输入内容',
  UNAUTHORIZED: '登录状态已失效，请重新登录',
}

export function formatApiError(error: unknown, fallback: string) {
  const info = getApiClientErrorInfo(error)
  const detail = info.detail
    ? detailTranslations.find(([pattern]) => pattern.test(info.detail!))?.[1] ?? info.detail
    : codeMessages[info.code] ?? fallback
  return info.requestId ? `${detail}（请求 ID：${info.requestId}）` : detail
}
